export const CATEGORY_TYPES = {
  GLOBAL: 'global',
  CATEGORY: 'categories',
}
